import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "container-fix-padding" }
const _hoisted_2 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_3 = { class: "ms-3 py-2 text-sm-subtitle-1 text-md-h6" }
const _hoisted_4 = { class: "d-flex justify-content-center" }
const _hoisted_5 = { class: "center-layout mt-3" }
const _hoisted_6 = {
  key: 0,
  class: "category-sidebar px-4 py-3"
}
const _hoisted_7 = { class: "category-count" }
const _hoisted_8 = { class: "category-count" }
const _hoisted_9 = {
  key: 0,
  class: "category-sidebar pa-3"
}
const _hoisted_10 = { class: "category-count" }
const _hoisted_11 = { class: "category-count" }
const _hoisted_12 = {
  key: 1,
  class: "text-center text-medium-emphasis py-10",
  role: "status"
}

import { ref, computed, onMounted, onBeforeUnmount, watch, nextTick, getCurrentInstance } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import ExamComponent from '../organisms/Exam.vue'
import ExamCategory from '../atoms_molecules/ExamCategory.vue'
import SubPage from '../atoms_molecules/SubPage.vue'
import ExamHistoryView from '../organisms/ExamHistoryView.vue'
import { LETTER_FORMAT } from '../../utils/constants'
import ExamModel from '../../models/exam'
import { subMonths } from 'date-fns'
import { examMyState } from '../../stores/exam_my'
import { userState } from '../../stores/user'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import ExamDashboardChart from '../atoms_molecules/ExamDashboardChart.vue'
import { checkMobile } from '../../utils/utils'
import { PageModeType } from '../../types'
import { getQueryString, getQueryNumber } from '../../../../helpers/route-helper'
import { makeChannel } from '../../../../action_cable/cable'

const NUMBER_PER_PAGE = 10


export default /*@__PURE__*/_defineComponent({
  __name: 'ExamMyList',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const isMobile = ref(false)
const mobile = ref(checkMobile())
const drawerRight = ref(!mobile.value)
const drawer = ref(false)
const endDate = ref(new Date().toString())
const startDate = ref(subMonths(new Date(), 1).toString())
const pageLoading = ref(true)
const search = ref("")
const title = ref("すべてのテスト")
const show = ref(true)
const isTeleportReady = ref(false)
const page = ref(1)
const pagingLoading = ref(false)
const isEndList = ref(false)
// URL に exam_id があるとき（レッスンの「今までのテスト結果を見る」など）は、最初から結果の画面にする。
// 一覧を先に描くと、切り替わるまでの一瞬だけテスト一覧が見えてしまう
const pageMode = ref<PageModeType>(getQueryString(route.query, 'exam_id') ? 'sub_page' : 'main_page')
const subPageExam = ref<ExamModel | null>(null)

const breadcrumbs = [
  { text: 'クラスルーム', disabled: false, exact: true, to: '/classroom/' },
  { text: 'マイテスト', disabled: false, exact: true, to: '/classroom/my-exams' }
]

const updateComponent = () => {
  show.value = false
  search.value = " "
  nextTick(() => {
    search.value = ""
    show.value = true
  })
}

const allExams = computed(() => examMyState.list)
const user = computed(() => userState.user)
const categories = computed(() => examMyState.categories)
const isShowGraph = computed(() => user.value?.isShowGraph)
const hasAnyExam = computed(() => examMyState.hasAnyExam)
const searchingExam = computed(() => examMyState.searchingExam)
const isLoading = computed(() => examMyState.isLoading || userState.isLoading)
const category = computed(() => examMyState.category)
const schoolSetting = computed(() => headerState.schoolSetting)

const getLastTestAt = (parentExam: ExamModel) => {
  let userExams = parentExam.userExams
  allExams.value
    .filter((exam) => exam.parentId == parentExam.id)
    .forEach((exam) => {
      userExams = [...userExams, ...exam.userExams]
    })
  return userExams.reduce(
    (lastTestAt: Date, userExam) => (lastTestAt && lastTestAt > userExam.createdAt ? lastTestAt : userExam.createdAt),
    userExams[0].createdAt
  )
}

const exams = computed(() => {
  const parentExams = allExams.value.filter((exam) => !exam.parentId)
  const parentExamPayloads = parentExams
    .map((exam) => ({ exam, lastTestAt: getLastTestAt(exam) }))
    .sort((a, b) => (a.lastTestAt > b.lastTestAt ? -1 : 1))
  return parentExamPayloads.map((payload) => payload.exam)
})

const totalExamCount = computed(() => exams.value.length)
const taggedExamCount = computed(() => {
  return categories.value.reduce((sum: number, cat: any) => sum + (Number(cat.examsCount) || 0), 0)
})
const untaggedExamCount = computed(() => Math.max(0, totalExamCount.value - taggedExamCount.value))

// Type-safe computed properties for route query params
const currentListId = computed(() => getQueryString(route.query, 'list_id'))
const currentListIdNumber = computed(() => getQueryNumber(route.query, 'list_id'))
const currentExamId = computed(() => getQueryString(route.query, 'exam_id'))
// 戻り先（レッスンから開いたとき）。/classroom/ で始まるパスだけ受ける
const returnTo = computed(() => { const value = getQueryString(route.query, 'return_to'); return value && value.startsWith('/classroom/') ? value : '' })
const currentStartDate = computed(() => getQueryString(route.query, 'start_date'))
const currentEndDate = computed(() => getQueryString(route.query, 'end_date'))

const findCategoryById = (id: number) => {
  for (let index = 0; index < categories.value.length; index++) {
    const cat = categories.value[index].find(id)
    if (cat) return cat
  }
  return null
}

const currentExams = computed(() => {
  let result = exams.value
  const listId = currentListId.value
  if (listId) {
    if (listId === 'no_tag') {
      result = exams.value.filter((exam) => {
        return !categories.value.some((cat: any) => cat.hasExam ? cat.hasExam(exam) : false)
      })
    } else {
      const cat = findCategoryById(Number(listId))
      result = cat ? cat.getExams(exams.value) : []
    }
  }
  if (result.slice(0, page.value * NUMBER_PER_PAGE).length == result.length) {
    isEndList.value = true
  }
  return result
})

const setNoTag = () => {
  router.push({ query: { list_id: 'no_tag' } })
}

const resetSearchValue = async () => {
  if (search.value) {
    search.value = ""
    await examMyState.getMyExams(startDate.value, endDate.value, "")
    resetPaging()
  }
}

const resetPaging = () => {
  page.value = 1
  isEndList.value = false
}

const resetCategory = async () => {
  router.replace({ query: {} })
}

const onSwitchMode = (mode: PageModeType) => {
  // テスト形式のレッスンから開いたとき（return_to）は、一覧ではなく元のレッスンに戻る
  if (mode === 'main_page' && returnTo.value) {
    router.push(returnTo.value)
    return
  }
  pageMode.value = mode
  router.push({ query: { ...route.query ?? {}, exam_id: undefined } })
}

const onShowHistories = (exam: ExamModel) => {
  if (currentExamId.value === exam.id.toString()) return
  pageMode.value = 'sub_page'
  subPageExam.value = exam
  router.push({ query: { ...route.query ?? {}, exam_id: exam.id.toString() } })
}

const handleScroll = (e: Event) => {
  const el = e.target as HTMLElement
  if (el && el.clientHeight + el.scrollTop >= el.scrollHeight && !pagingLoading.value && !isEndList.value) {
    pagingLoading.value = true
    setTimeout(() => {
      pagingLoading.value = false
      page.value += 1
    }, 2000)
  }
}

const onResize = () => {
  isMobile.value = window.innerWidth < 600
}

const getExamsByQuery = async (start: string, end: string, categoryId: string) => {
  const catId = categoryId == undefined ? '' : categoryId
  const s = start == undefined ? '' : start
  const e = end == undefined ? '' : end
  await examMyState.getMyExams(s, e, catId)
  resetPaging()
}

const onChangeQueryRoute = async () => {
  let categoryId = currentListId.value
  let start = currentStartDate.value
  let end = currentEndDate.value
  if (categoryId == undefined && start == undefined && end == undefined) {
    if (user.value?.lastExamAt) {
      end = user.value.lastExamAt as any
      start = subMonths(new Date(end as string), 1).toString()
    } else {
      end = new Date().toString()
      start = subMonths(new Date(), 1).toString()
    }
  }
  await getExamsByQuery(start as string, end as string, categoryId as string)
  startDate.value = start as string
  endDate.value = end as string
  if (categoryId && findCategoryById(Number(categoryId)) != category.value) {
    if (exams.value.length > 0) {
      endDate.value = exams.value[0].userExam.createdAt.toString()
      startDate.value = exams.value[exams.value.length - 1].userExams.slice(-1)[0].createdAt.toString()
    }
  }
  if (categoryId) {
    const cat = findCategoryById(Number(categoryId))
    title.value = cat ? cat.name : 'すべてのテスト'
  } else {
    title.value = 'すべてのテスト'
  }

  if (currentExamId.value) {
    const exam = allExams.value.find(item => item.id.toString() === currentExamId.value)
    if (exam && subPageExam.value?.id !== exam.id) {
      pageMode.value = 'sub_page'
      subPageExam.value = exam
    } else if (!exam && !subPageExam.value) {
      pageMode.value = 'main_page' // そのテストが一覧に無いときは、一覧を出す
    }
  }
}

let notificationChannel: ReturnType<typeof makeChannel> | null = null

const initChannel = async () => {
  notificationChannel = makeChannel(
    'NotificationChannel',
    (e: any) => {
      if (e.content == 'marked_exam') updateComponent()
    },
    () => { notificationChannel?.send({ action: 'follow' }) }
  )
}

watch(search, async () => {
  if (search.value) {
    title.value = "テスト検索"
    await examMyState.searchMyExam(search.value, startDate.value, endDate.value)
  } else {
    examMyState.searchingExam = false
    await onChangeQueryRoute()
  }
})

watch(() => route.query, async () => {
  await onChangeQueryRoute()
})

onMounted(async () => {
  await initChannel()
  await userState.getUser()
  await examMyState.getMyCategories()
  footerState.setFooterDefault()
  pageLoading.value = false
  await onChangeQueryRoute()
  headerState.setTitle('テスト一覧')
  window.addEventListener('scroll', handleScroll)
  onResize()
  window.addEventListener('resize', onResize)
  nextTick(() => {
    isTeleportReady.value = !!document.querySelector('#header-right')
  })
})

onBeforeUnmount(() => {
  notificationChannel?.unsubscribe()
  notificationChannel = null
  if (typeof window !== 'undefined') {
    window.removeEventListener('resize', onResize)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(SubPage, {
    pageMode: pageMode.value,
    onSwitchMode: onSwitchMode,
    backLabel: returnTo.value ? 'レッスンに戻る' : '戻る'
  }, {
    main_page: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_AppBreadcrumb, { items: [
          { text: 'クラスルーム', to: '/classroom/' },
          { text: 'マイテスト' }
        ] }),
        _cache[22] || (_cache[22] = _createElementVNode("p", {
          class: "text-muted px-3 py-2 mb-2",
          style: {"font-size":"13px"}
        }, "AIとの会話で作った練習は、各レッスンの「練習履歴」から再開・振り返りできます。", -1 /* CACHED */)),
        _createCommentVNode(" Main content: 2-column layout "),
        _createVNode(_component_v_row, {
          class: "ma-0",
          style: { minHeight: '700px' }
        }, {
          default: _withCtx(() => [
            _createCommentVNode(" Left column: Exam list "),
            (exams.value.length > 0 || hasAnyExam.value || searchingExam.value)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "12",
                  lg: "8",
                  class: "pt-0 bg-white"
                }, {
                  default: _withCtx(() => [
                    (isShowGraph.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createVNode(ExamDashboardChart, {
                            exams: currentExams.value,
                            startDate: startDate.value,
                            endDate: endDate.value
                          }, null, 8 /* PROPS */, ["exams", "startDate", "endDate"])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (isShowGraph.value)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 1,
                          class: "bg-grey-lighten-3",
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "8",
                              class: "pa-0"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, _toDisplayString(`${title.value}の結果`), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Search bar row "),
                    _createVNode(_component_v_row, {
                      class: "align-center px-3 py-2",
                      "no-gutters": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "8",
                          md: "9"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: search.value,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                              placeholder: "テスト名を入力してください",
                              "prepend-inner-icon": "mdi-magnify",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              clearable: ""
                            }, null, 8 /* PROPS */, ["modelValue"])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, {
                          cols: "4",
                          md: "3",
                          class: "d-flex justify-end align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              variant: "outlined",
                              onClick: resetSearchValue
                            }, {
                              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                _createTextVNode("クリア", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createElementVNode("div", null, [
                      (show.value)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(currentExams.value, (exam, index) => {
                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                              _createVNode(ExamComponent, {
                                exam: exam,
                                isMine: true,
                                list: allExams.value,
                                schoolSetting: schoolSetting.value,
                                onFetchList: onChangeQueryRoute,
                                onShowHistories: onShowHistories
                              }, null, 8 /* PROPS */, ["exam", "list", "schoolSetting"])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", _hoisted_4, [
                        (pagingLoading.value)
                          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                              key: 0,
                              indeterminate: "",
                              color: "green",
                              class: "loading"
                            }))
                          : _createCommentVNode("v-if", true)
                      ])
                    ])
                  ]),
                  _: 1 /* STABLE */
                }))
              : (exams.value.length == 0 && !isLoading.value && !pageLoading.value)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 1,
                    cols: "12",
                    lg: "8",
                    class: "bg-white"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "mt-5" }, "受けたテストはありません", -1 /* CACHED */)),
                        _cache[10] || (_cache[10] = _createElementVNode("p", { class: "mb-1" }, "受けたテストはこちらに表示されます。", -1 /* CACHED */)),
                        _createVNode(_component_router_link, {
                          to: "/classroom",
                          class: "text-decoration-none"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              outlined: "",
                              color: "success"
                            }, {
                              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                _createTextVNode(" クラスルームに戻る ", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createCommentVNode(" <h2 class=\"mt-5\">さっそくテストを始めましょう</h2>\n              <p class=\"mb-1\">まだテストをひとつも</p>\n              <p class=\"mb-1\">受けていません。テスト一覧から</p>\n              <p class=\"mb-1\">テストを受けましょう。</p> "),
                        _createCommentVNode(" <router-link to=\"/classroom/exam-list\" class=\"text-decoration-none\">\n                <v-btn outlined color=\"success\">\n                  {{ $t('exam_list.go_test_list', { format: LETTER_FORMAT.UPTITLECASE }) }}\n                </v-btn>\n              </router-link> ")
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
            _createCommentVNode(" Right column: Categories (desktop only) "),
            (!mobile.value)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 2,
                  cols: "12",
                  lg: "4",
                  class: "bg-white"
                }, {
                  default: _withCtx(() => [
                    (!pageLoading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "category-header d-flex align-center justify-space-between mb-3" }, [
                            _createElementVNode("div", { class: "d-flex align-center gap-2" }, [
                              _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "20",
                                height: "20",
                                viewBox: "0 0 24 24",
                                fill: "currentColor",
                                class: "text-primary"
                              }, [
                                _createElementVNode("path", { d: "M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM9 9H5V5h4v4zm11-6h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 6h-4V5h4v4zm-9 4H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm-1 6H5v-4h4v4zm8-6c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z" })
                              ]),
                              _createElementVNode("span", { class: "text-h6 font-weight-bold" }, "カテゴリー")
                            ])
                          ], -1 /* CACHED */)),
                          _createCommentVNode(" Clear/All exams button "),
                          _createElementVNode("div", {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (resetCategory())),
                            class: _normalizeClass(["category-clear-btn d-flex align-center gap-2 pa-3 mb-2 rounded-lg", { 'active': !currentListId.value }])
                          }, [
                            _cache[11] || (_cache[11] = _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "18",
                              height: "18",
                              viewBox: "0 0 24 24",
                              fill: "currentColor"
                            }, [
                              _createElementVNode("path", { d: "M4 6h16v2H4zm2 4h12v2H6zm2 4h8v2H8z" })
                            ], -1 /* CACHED */)),
                            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "font-weight-medium" }, "すべてのテスト", -1 /* CACHED */)),
                            _createVNode(_component_v_spacer),
                            _createElementVNode("span", _hoisted_7, _toDisplayString(totalExamCount.value), 1 /* TEXT */)
                          ], 2 /* CLASS */),
                          _createVNode(_component_v_divider, { class: "mb-2" }),
                          _createCommentVNode(" Category list "),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category, index) => {
                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                              _createVNode(ExamCategory, {
                                exams: exams.value,
                                category: category,
                                padding: 0,
                                visible: true
                              }, null, 8 /* PROPS */, ["exams", "category"])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */)),
                          _createCommentVNode(" No tag item "),
                          (untaggedExamCount.value > 0)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (setNoTag())),
                                class: _normalizeClass(["category-item d-flex align-center gap-2 pa-3 mb-1 rounded-lg", { 'active': currentListId.value === 'no_tag' }])
                              }, [
                                _cache[13] || (_cache[13] = _createElementVNode("svg", {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "16",
                                  height: "16",
                                  viewBox: "0 0 24 24",
                                  fill: "currentColor",
                                  class: "me-2 text-grey"
                                }, [
                                  _createElementVNode("path", { d: "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z" })
                                ], -1 /* CACHED */)),
                                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "font-weight-medium" }, "タグなし", -1 /* CACHED */)),
                                _createVNode(_component_v_spacer),
                                _createElementVNode("span", _hoisted_8, _toDisplayString(untaggedExamCount.value), 1 /* TEXT */)
                              ], 2 /* CLASS */))
                            : _createCommentVNode("v-if", true)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }),
        _createCommentVNode(" Mobile menu button "),
        (_openBlock(), _createBlock(_Teleport, {
          to: "#header-right",
          disabled: !isTeleportReady.value
        }, [
          (mobile.value)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                icon: "",
                variant: "text",
                color: "white",
                size: "small",
                class: "filter-right ms-2",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (drawerRight.value = !drawerRight.value), ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                      _createTextVNode("mdi-filter-variant", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ], 8 /* PROPS */, ["disabled"])),
        _createCommentVNode(" Mobile drawer "),
        (_openBlock(), _createBlock(_Teleport, {
          to: "#header-right-drawer",
          disabled: !isTeleportReady.value
        }, [
          (mobile.value)
            ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
                key: 0,
                modelValue: drawerRight.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((drawerRight).value = $event)),
                location: "right",
                temporary: ""
              }, {
                default: _withCtx(() => [
                  (!pageLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _cache[21] || (_cache[21] = _createElementVNode("div", { class: "category-header d-flex align-center gap-2 mb-3" }, [
                          _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "currentColor",
                            class: "text-primary"
                          }, [
                            _createElementVNode("path", { d: "M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM9 9H5V5h4v4zm11-6h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm-1 6h-4V5h4v4zm-9 4H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm-1 6H5v-4h4v4zm8-6c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z" })
                          ]),
                          _createElementVNode("span", { class: "text-h6 font-weight-bold" }, "カテゴリー")
                        ], -1 /* CACHED */)),
                        _createCommentVNode(" Clear/All exams button "),
                        _createElementVNode("div", {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => {resetCategory(); drawerRight.value = false}),
                          class: _normalizeClass(["category-clear-btn d-flex align-center gap-2 pa-3 mb-2 rounded-lg", { 'active': !currentListId.value }])
                        }, [
                          _cache[17] || (_cache[17] = _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "18",
                            height: "18",
                            viewBox: "0 0 24 24",
                            fill: "currentColor"
                          }, [
                            _createElementVNode("path", { d: "M4 6h16v2H4zm2 4h12v2H6zm2 4h8v2H8z" })
                          ], -1 /* CACHED */)),
                          _cache[18] || (_cache[18] = _createElementVNode("span", { class: "font-weight-medium" }, "すべてのテスト", -1 /* CACHED */)),
                          _createVNode(_component_v_spacer),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(totalExamCount.value), 1 /* TEXT */)
                        ], 2 /* CLASS */),
                        _createVNode(_component_v_divider, { class: "mb-2" }),
                        _createCommentVNode(" Category list "),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createVNode(ExamCategory, {
                              exams: exams.value,
                              category: category,
                              padding: 0,
                              visible: true
                            }, null, 8 /* PROPS */, ["exams", "category"])
                          ]))
                        }), 128 /* KEYED_FRAGMENT */)),
                        _createCommentVNode(" No tag item "),
                        (untaggedExamCount.value > 0)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              onClick: _cache[5] || (_cache[5] = ($event: any) => {setNoTag(); drawerRight.value = false}),
                              class: _normalizeClass(["category-item d-flex align-center gap-2 pa-3 mb-1 rounded-lg", { 'active': currentListId.value === 'no_tag' }])
                            }, [
                              _cache[19] || (_cache[19] = _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "currentColor",
                                class: "me-2 text-grey"
                              }, [
                                _createElementVNode("path", { d: "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z" })
                              ], -1 /* CACHED */)),
                              _cache[20] || (_cache[20] = _createElementVNode("span", { class: "font-weight-medium" }, "タグなし", -1 /* CACHED */)),
                              _createVNode(_component_v_spacer),
                              _createElementVNode("span", _hoisted_11, _toDisplayString(untaggedExamCount.value), 1 /* TEXT */)
                            ], 2 /* CLASS */))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"]))
            : _createCommentVNode("v-if", true)
        ], 8 /* PROPS */, ["disabled"]))
      ])
    ]),
    sub_page: _withCtx(() => [
      (subPageExam.value)
        ? (_openBlock(), _createBlock(ExamHistoryView, {
            key: 0,
            exam: subPageExam.value,
            list: allExams.value,
            schoolSetting: schoolSetting.value,
            onFetchList: onChangeQueryRoute
          }, null, 8 /* PROPS */, ["exam", "list", "schoolSetting"]))
        : (_openBlock(), _createElementBlock("p", _hoisted_12, "結果を読み込んでいます…"))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["pageMode", "backLabel"]))
}
}

})